export default {
  default: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/layouts/default.vue").then(m => m.default || m),
  iframe: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/layouts/iframe.vue").then(m => m.default || m),
  preview: () => import("/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/layouts/preview.vue").then(m => m.default || m)
}